import { KEY_MENU } from 'constants/index';
import { AppRoutes, ContractRoutes, RoutesV1 } from 'constants/appRoutes';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function useActiveMenu() {
	const [menuActive, setMenuActive] = useState('');

	let location = useLocation();

	useEffect(() => {
		switch (location.pathname) {
			case AppRoutes.home:
				setMenuActive(KEY_MENU.home);
				break;
			case ContractRoutes.contract:
			case ContractRoutes.contract_detail:
			case ContractRoutes.product_detail:
			case ContractRoutes.payment:
			case ContractRoutes.change_condition:
			case ContractRoutes.benefit:
			case ContractRoutes.contract_master:
			case ContractRoutes.free_master:
			case ContractRoutes.ebill_master:
			case ContractRoutes.due_freemaster:
				setMenuActive(KEY_MENU.contract);
				break;
			case AppRoutes.gift:
				setMenuActive(KEY_MENU.gift);
				break;
			case AppRoutes.productsAndServices:
				setMenuActive(KEY_MENU.service);
				break;
			case AppRoutes.contactUs:
				setMenuActive(KEY_MENU.contact);
				break;
			case RoutesV1.premiumPayment:
				setMenuActive(KEY_MENU.premiumPayment);
				break;
			default:
				setMenuActive('');
				break;
		}
		return () => {};
	}, [location]);

	return menuActive;
}
